import { useState } from "react";
import { useMainContext } from "../../../Context";
import { sendComment } from "../../../Utils/Apis";

export const useCommnet = ({ id, rel }) => {
  const {
    post,
    state: { user },
  } = useMainContext();
  const [form, setForm] = useState({});
  const [loadingBtn, setloadingBtn] = useState(false);

  const renderImg = () => {
    if (user && user.photo && user.photo[0]) {
      return user.photo[0];
    } else {
      return require("../../../Assets/images/userimage.png");
    }
  };
  const renderData = data => {
    switch (data.user_type) {
      case "admin":
        return {
          text: "پشتیبان",
          right: true,
          status: false,
          label: null,
          img: require("../../../Assets/images/userimage.png"),
        };
        break;
      case "manager":
        return {
          text: "مدیریت مجموعه",
          right: false,
          status: "active",
          label: <span className="badge bg-success">فعال</span>,
          img: require("../../../Assets/images/user.png"),
        };

      case "user":
        return {
          text: data?.commenter?.fullname,
          right: false,
          status: "active",
          label: <span className="badge bg-success">فعال</span>,
          img: data?.commenter?.photo[0],
        };

      default:
        break;
    }
  };
  const storeComment = async text => {
    setloadingBtn(true);
    await post(sendComment, { [rel]: id, text }, true);
    setloadingBtn(false);
  };
  return {
    form,
    setForm,
    renderImg,
    renderData,
    user,
    loadingBtn,
    storeComment,
  };
};
